(function () {
  var container = document.getElementById('HairKit');
  if (!container) return;

  var state = { gender: null, stage: null, dandruff: null };

  var stageImages = {};
  try {
    stageImages = JSON.parse(container.getAttribute('data-stage-images') || '{}');
  } catch (e) {}

  var stages = {
    male: [
      { value: 'stage-1', label: 'Stage 1', img: stageImages['male-1'] || '' },
      { value: 'stage-2', label: 'Stage 2', img: stageImages['male-2'] || '' },
      { value: 'stage-3', label: 'Stage 3', img: stageImages['male-3'] || '' },
      { value: 'stage-4', label: 'Stage 4', img: stageImages['male-4'] || '' }
    ],
    female: [
      { value: 'stage-1', label: 'Stage 1', img: stageImages['female-1'] || '' },
      { value: 'stage-2', label: 'Stage 2', img: stageImages['female-2'] || '' },
      { value: 'stage-3', label: 'Stage 3', img: stageImages['female-3'] || '' }
    ]
  };


  var productMapping = {};
  try {
    var raw = container.getAttribute('data-product-mapping');
    if (raw && raw !== '{}') productMapping = JSON.parse(raw);
  } catch (e) {}

  var FALLBACK_HANDLE = 'seltyca-hair-fall-kit-no-dandruff';
  var currentVariantId = null;

  // Product mapping: gender > stage > condition = product handle
  // Uses real products from /collections/hair-care
  if (!Object.keys(productMapping).length) {
    productMapping = {
      "male": {
        "stage-1": { "with-dandruff": "seltyca-stage-1-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-1-hair-fall-kit-no-dandruff-hydrating-base" },
        "stage-2": { "with-dandruff": "seltyca-stage-2-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-2-hair-fall-kit-no-dandruff" },
        "stage-3": { "with-dandruff": "seltyca-stage-3-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-3-hair-fall-kit-no-dandruff" },
        "stage-4": { "with-dandruff": "seltyca-stage-4-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-4-hair-fall-kit-no-dandruff" }
      },
      "female": {
        "stage-1": { "with-dandruff": "seltyca-stage-1-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-1-hair-fall-kit-no-dandruff-hydrating-base" },
        "stage-2": { "with-dandruff": "seltyca-stage-2-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-2-hair-fall-kit-no-dandruff" },
        "stage-3": { "with-dandruff": "seltyca-stage-3-hair-fall-kit-with-dandruff", "no-dandruff": "seltyca-stage-3-hair-fall-kit-no-dandruff" }
      }
    };
  }
  var originalImgSrc = '';
  var mediaImg = container.querySelector('.hair-kit__media-image');
  if (mediaImg) originalImgSrc = mediaImg.src;

  var step2 = container.querySelector('[data-step="2"]');
  var step3 = container.querySelector('[data-step="3"]');
  var resultEl = document.getElementById('HairKitResult');

  function getProductHandle() {
    try {
      var dandruffKey = state.dandruff === 'yes' ? 'with-dandruff' : 'no-dandruff';
      return productMapping[state.gender][state.stage][dandruffKey] || FALLBACK_HANDLE;
    } catch (e) {
      return FALLBACK_HANDLE;
    }
  }

  function updateSteps() {
    // Unlock step 2 when gender selected
    step2.classList.toggle('is-locked', !state.gender);

    // Unlock step 3 (dandruff) when stage selected
    step3.classList.toggle('is-locked', !state.stage);

    // Show result when all selected
    if (state.gender && state.stage && state.dandruff) {
      loadResult();
    } else {
      resultEl.classList.remove('is-visible');
    }
  }

  function renderStages() {
    var wrap = container.querySelector('[data-step="2"] .hair-kit__options');
    var items = stages[state.gender] || [];
    wrap.innerHTML = items.map(function (s) {
      return '<div class="hair-kit__option hair-kit__option--stage" data-stage="' + s.value + '">' +
        '<img class="hair-kit__stage-img" src="' + s.img + '" alt="' + s.label + '">' +
        '<span>' + s.label + '</span>' +
        '</div>';
    }).join('');

    // Bind stage clicks
    wrap.querySelectorAll('.hair-kit__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        state.stage = this.dataset.stage;
        selectInGroup(wrap, this);
        updateSteps();
      });
    });

    // Auto-select first stage
    var firstStage = wrap.querySelector('.hair-kit__option');
    if (firstStage) {
      state.stage = firstStage.dataset.stage;
      firstStage.classList.add('is-selected');
    }
  }

  function selectInGroup(parent, selected) {
    parent.querySelectorAll('.hair-kit__option').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    selected.classList.add('is-selected');
  }

  var hairKitSwiper = null;

  function clearSkeleton() {
    var mediaEl = container.querySelector('.hair-kit__media');
    if (mediaEl) {
      mediaEl.style.background = 'none';
      mediaEl.style.animation = 'none';
    }
  }

  function showSkeleton() {
    var mediaEl = container.querySelector('.hair-kit__media');
    if (mediaEl) {
      mediaEl.style.background = '';
      mediaEl.style.animation = '';
    }
  }

  function renderThumbnails(images) {
    var thumbsWrap = document.getElementById('HairKitThumbnails');
    var swiperWrapper = document.getElementById('HairKitSwiperWrapper');

    // Destroy existing swiper
    if (hairKitSwiper) {
      hairKitSwiper.destroy(true, true);
      hairKitSwiper = null;
    }

    if (!images || images.length <= 1) {
      thumbsWrap.innerHTML = '';
      if (images && images.length === 1) {
        swiperWrapper.innerHTML = '<div class="swiper-slide"><img class="hair-kit__media-image" src="' + images[0] + '" alt="Product image"></div>';
      }
      clearSkeleton();
      return;
    }

    // Build swiper slides
    swiperWrapper.innerHTML = images.map(function (src, i) {
      return '<div class="swiper-slide"><img class="hair-kit__media-image" src="' + src + '" alt="Product image ' + (i + 1) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '"></div>';
    }).join('');

    // Build thumbnails (desktop)
    thumbsWrap.innerHTML = images.map(function (src, i) {
      return '<div class="hair-kit__thumb' + (i === 0 ? ' is-active' : '') + '" data-img-index="' + i + '">' +
        '<img src="' + src + '" alt="Product image ' + (i + 1) + '" loading="lazy">' +
        '</div>';
    }).join('');

    // Init Swiper
    var SwiperClass = window.Swiper || (window.FoxTheme && window.FoxTheme.Swiper && window.FoxTheme.Swiper.Swiper);
    if (SwiperClass) {
      hairKitSwiper = new SwiperClass('#HairKitCarousel', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        grabCursor: true,
        allowTouchMove: true,
        autoHeight: true,
        threshold: 2,
        navigation: {
          nextEl: '#HairKitCarousel .swiper-button-next',
          prevEl: '#HairKitCarousel .swiper-button-prev',
        },
        pagination: {
          el: '#HairKitCarousel .swiper-pagination',
          clickable: true,
          type: 'fraction',
        },
        on: {
          slideChange: function () {
            var idx = this.realIndex;
            thumbsWrap.querySelectorAll('.hair-kit__thumb').forEach(function (t, i) {
              t.classList.toggle('is-active', i === idx);
            });
          }
        }
      });

      // Thumbnail clicks go to slide
      thumbsWrap.querySelectorAll('.hair-kit__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(this.dataset.imgIndex);
          if (hairKitSwiper) hairKitSwiper.slideToLoop(idx);
        });
      });
    }

    clearSkeleton();
  }

  function loadResult() {
    var handle = getProductHandle();
    showSkeleton();

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Not found');
        return r.json();
      })
      .then(function (product) {
        currentVariantId = product.variants[0].id;
        document.getElementById('HairKitPageTitle').textContent = product.title;
        renderThumbnails(product.images);
        var priceRow = document.getElementById('HairKitPriceRow');
        var priceEl = document.getElementById('HairKitProductPrice');
        var compareEl = document.getElementById('HairKitComparePrice');
        var discountEl = document.getElementById('HairKitDiscount');
        var variant = product.variants[0];
        priceEl.textContent = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          discountEl.textContent = '(' + pct + '% off)';
          compareEl.style.display = '';
          discountEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
          discountEl.style.display = 'none';
        }
        priceRow.style.display = 'flex';
        document.getElementById('HairKitBuyNow').href = '/cart/' + currentVariantId + ':1';
        // Update sticky bar
        var stickyBuy = document.getElementById('HairKitStickyBuy');
        if (stickyBuy) stickyBuy.href = '/cart/' + currentVariantId + ':1';
        var stickyImg = document.getElementById('HairKitStickyImg');
        if (stickyImg && product.featured_image) stickyImg.src = product.featured_image;
        var stickyTitle = document.getElementById('HairKitStickyTitle');
        if (stickyTitle) stickyTitle.textContent = product.title;
        var stickyPrice = document.getElementById('HairKitStickyPrice');
        if (stickyPrice) {
          var priceHtml = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            var pctOff = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            priceHtml = '<span class="s-compare">' + formatMoney(variant.compare_at_price) + '</span> ';
            priceHtml += '<span class="s-sale">' + formatMoney(variant.price) + '</span> ';
            priceHtml += '<span class="s-off">(' + pctOff + '% off)</span>';
          } else {
            priceHtml = '<span class="s-sale">' + formatMoney(variant.price) + '</span>';
          }
          stickyPrice.innerHTML = priceHtml;
        }
        var tabsEl = document.getElementById('HairKitTabs');
        var descEl = document.getElementById('HairKitDescription');
        var howToUseEl = document.getElementById('HairKitHowToUse');
        var hasDescription = product.description && product.description.trim();
        var hasHowToUse = false;

        if (hasDescription) {
          descEl.innerHTML = product.description;
        }

        // Populate How to Use from pre-rendered metafield data
        var howToUseDataEl = document.getElementById('HairKitHowToUseData');
        if (howToUseDataEl) {
          try {
            var howToUseMap = JSON.parse(howToUseDataEl.textContent);
            var steps = howToUseMap[handle];
            if (steps && steps.length) {
              hasHowToUse = true;
              var html = '<div class="how-to-use-steps">';
              steps.forEach(function (step, i) {
                var num = i + 1;
                html += '<div class="how-to-use-step">';
                html += '<div class="how-to-use-number"><svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#082654"/><text x="20" y="21" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="16" font-weight="700" font-family="sans-serif">' + num + '</text></svg></div>';
                html += '<div class="how-to-use-text">';
                var titleText = '';
                if (step.rest) {
                  titleText = '<strong>' + step.title + '</strong> – ' + step.rest;
                } else {
                  titleText = step.title;
                }
                html += '<p class="step-description">' + titleText + '</p>';
                html += '</div></div>';
              });
              html += '</div>';
              howToUseEl.innerHTML = html;
            }
          } catch (e) {}
        }

        if (hasDescription || hasHowToUse) {
          tabsEl.style.display = 'block';
          // Show/hide individual tabs based on available data
          var detailsBtn = tabsEl.querySelector('[data-tab="details"]');
          var howToUseBtn = tabsEl.querySelector('[data-tab="how-to-use"]');
          if (detailsBtn) detailsBtn.style.display = hasDescription ? '' : 'none';
          if (howToUseBtn) howToUseBtn.style.display = hasHowToUse ? '' : 'none';
          // Activate first available tab
          if (hasDescription) {
            if (detailsBtn) detailsBtn.click();
          } else if (hasHowToUse) {
            if (howToUseBtn) howToUseBtn.click();
          }
        } else {
          tabsEl.style.display = 'none';
        }
        resultEl.classList.add('is-visible');
      })
      .catch(function () {
        resultEl.classList.remove('is-visible');
      });
  }

  function formatMoney(cents) {
    return '\u20B9' + (cents / 100).toLocaleString('en-IN');
  }

  function resetAll() {
    state.gender = null;
    state.stage = null;
    state.dandruff = null;
    container.querySelectorAll('.hair-kit__option').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    if (mediaImg) {
      mediaImg.src = originalImgSrc;
    }
    updateSteps();
  }

  // Gender clicks
  container.querySelectorAll('[data-gender]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.gender = this.dataset.gender;
      state.stage = null;
      state.dandruff = 'yes';
      selectInGroup(this.parentElement, this);
      renderStages();
      // Re-select "Yes" dandruff
      container.querySelectorAll('#HairKitDandruff .hair-kit__option').forEach(function (o) { o.classList.remove('is-selected'); });
      var yesDandruff = container.querySelector('[data-dandruff="yes"]');
      if (yesDandruff) yesDandruff.classList.add('is-selected');
      updateSteps();
    });
  });

  // Stage clicks are now handled dynamically by renderStages()

  // Dandruff clicks
  container.querySelectorAll('[data-dandruff]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.dandruff = this.dataset.dandruff;
      selectInGroup(this.parentElement, this);
      updateSteps();
    });
  });

  // Restart
  var restartBtn = container.querySelector('[data-restart]');
  if (restartBtn) {
    restartBtn.addEventListener('click', resetAll);
  }

  // Tab switching
  container.querySelectorAll('.hair-kit__tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = this.dataset.tab;
      container.querySelectorAll('.hair-kit__tab-btn').forEach(function (b) { b.classList.remove('is-active'); });
      container.querySelectorAll('.hair-kit__tab-content').forEach(function (c) { c.classList.remove('is-active'); });
      this.classList.add('is-active');
      container.querySelector('[data-tab-content="' + tab + '"]').classList.add('is-active');
    });
  });

  // Shared Add to Cart function
  function addToCart(btn) {
    if (!currentVariantId) return;
    btn.disabled = true;
    btn.querySelector('span').textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: currentVariantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.querySelector('span').textContent = 'Added!';
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var countEls = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
          countEls.forEach(function(el){ el.textContent = cart.item_count; });
        });
        setTimeout(function () {
          btn.disabled = false;
          btn.querySelector('span').textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function () {
        btn.querySelector('span').textContent = 'Error — Try Again';
        btn.disabled = false;
      });
  }

  // Add to Cart buttons
  var atcBtn = document.getElementById('HairKitAddToCart');
  if (atcBtn) atcBtn.addEventListener('click', function () { addToCart(this); });

  var stickyAtcBtn = document.getElementById('HairKitStickyATC');
  if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', function () { addToCart(this); });

  // Sticky bar - observe main result area
  var stickyBar = document.getElementById('HairKitStickyBar');
  if (stickyBar && resultEl) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = entry.intersectionRatio !== 1 && resultEl.classList.contains('is-visible');
        stickyBar.classList.toggle('hair-kit__sticky-bar--show', show);
      });
    }, { threshold: 1, rootMargin: '-80px 0px 0px 0px' });
    observer.observe(resultEl);
  }

  // Auto-select first option in each step on load
  function initDefaults() {
    // Select first gender
    var firstGender = container.querySelector('[data-gender]');
    if (firstGender) {
      state.gender = firstGender.dataset.gender;
      firstGender.classList.add('is-selected');
      renderStages();
    }

    // Select "Yes" dandruff by default
    var firstDandruff = container.querySelector('[data-dandruff="yes"]');
    if (firstDandruff) {
      state.dandruff = 'yes';
      firstDandruff.classList.add('is-selected');
    }

    updateSteps();
  }

  initDefaults();

  // Preload all product images after page loads
  function preloadAllProducts() {
    var handles = [];
    Object.keys(productMapping).forEach(function (gender) {
      Object.keys(productMapping[gender]).forEach(function (stage) {
        Object.keys(productMapping[gender][stage]).forEach(function (condition) {
          var handle = productMapping[gender][stage][condition];
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
      });
    });

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (product.images && product.images.length) {
            product.images.forEach(function (src) {
              var img = new Image();
              img.src = src;
            });
          }
        })
        .catch(function () {});
    });
  }

  // Start preloading after page is fully loaded
  if (document.readyState === 'complete') {
    setTimeout(preloadAllProducts, 1000);
  } else {
    window.addEventListener('load', function () {
      setTimeout(preloadAllProducts, 1000);
    });
  }
})();
